const BACKEND_ENUM_TO_FRONTEND_TYPE = {
    TASK: "Task",
    PROJECT: "Project",
    NOTE: "Note",
    RECALL_CARD_FOLDER: "Recall Card",
    CUSTOM_ITEM: "Custom item",
};

const TIME_PREFIX_PATTERN = /^(\d{2}:\d{2}-\d{2}:\d{2})\s*\|\s*(.*)/;
const FULL_WEEKDAY_KEYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

function toArray(value) {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    return [value];
}

function denormalizeScheduleItem(backendItem) {
    if (typeof backendItem === "string") {
        return { type: "Custom item", title: backendItem, startTime: "", endTime: "", refId: null };
    }

    const frontendType = BACKEND_ENUM_TO_FRONTEND_TYPE[backendItem?.type] ?? "Custom item";
    const rawCustomItem = String(backendItem?.custom_item || "").trim();

    const timeMatch = TIME_PREFIX_PATTERN.exec(rawCustomItem);
    let title = rawCustomItem;
    let startTime = "";
    let endTime = "";

    if (timeMatch) {
        const [startPart, endPart] = timeMatch[1].split("-");
        startTime = startPart ?? "";
        endTime = endPart ?? "";
        title = timeMatch[2].trim();
    }

    return {
        type: frontendType,
        title,
        startTime,
        endTime,
        refId: backendItem?.item_id ?? null,
    };
}

function denormalizeDailyFocusItem(backendItem, index) {
    if (typeof backendItem === "string") {
        return {
            id: `home-focus-${index}`,
            type: "Custom item",
            title: backendItem,
            startTime: "",
            endTime: "",
            itemRefId: null,
        };
    }

    const rawCustomItem = String(backendItem?.custom_item || "").trim();
    const timeMatch = TIME_PREFIX_PATTERN.exec(rawCustomItem);
    const [startTime = "", endTime = ""] = timeMatch?.[1]?.split("-") || [];
    const title = (timeMatch ? timeMatch[2] : rawCustomItem)
        .replace(/\s+\(\d+x\)$/, "")
        .replace(/\s+\[\d+(?:\.\d+)?h\]$/, "")
        .trim();

    return {
        id: `home-focus-${index}`,
        type: BACKEND_ENUM_TO_FRONTEND_TYPE[backendItem?.type] ?? "Custom item",
        title,
        startTime,
        endTime,
        itemRefId: backendItem?.item_id ?? null,
    };
}

export function buildDailyPlanFromPlannerOverview(backendPlanner) {
    return {
        mainOutcome: backendPlanner?.main_outcome || "",
        focusItems: toArray(backendPlanner?.daily_work_items)
            .map(denormalizeDailyFocusItem)
            .filter((item) => item.title),
    };
}

export function buildWeekBreakdownFromPlannerOverview(backendPlanner) {
    const weekBreakdown = {
        Mon: toArray(backendPlanner?.monday_work_items).map(denormalizeScheduleItem),
        Tue: toArray(backendPlanner?.tuesday_work_items).map(denormalizeScheduleItem),
        Wed: toArray(backendPlanner?.wednesday_work_items).map(denormalizeScheduleItem),
        Thu: toArray(backendPlanner?.thursday_work_items).map(denormalizeScheduleItem),
        Fri: toArray(backendPlanner?.friday_work_items).map(denormalizeScheduleItem),
        Sat: toArray(backendPlanner?.saturday_work_items).map(denormalizeScheduleItem),
        Sun: toArray(backendPlanner?.sunday_work_items).map(denormalizeScheduleItem),
    };

    return FULL_WEEKDAY_KEYS.reduce((acc, dayKey) => ({
        ...acc,
        [dayKey]: Array.isArray(weekBreakdown[dayKey]) ? weekBreakdown[dayKey] : [],
    }), {});
}
